import { DatePicker, TimePicker } from '@trackman/web-shared-components';
import dayjs, { Dayjs } from 'dayjs';

import { observer } from 'mobx-react-lite';
import { useCallback } from 'react';
import { useStores } from 'index';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export const DateAndTimeSettings = observer(() => {
  const es = useStores().trackmanEventsEditorStore;

  const getCombinedUTC = useCallback(
    (newValue: Dayjs) => {
      if (!newValue.isValid()) {
        return (es.eventItem.startDate = '');
      }
      const combined = dayjs
        .utc()
        .year(newValue.year())
        .month(newValue.month())
        .date(newValue.date())
        .hour(newValue.hour())
        .minute(newValue.minute())
        .second(0)
        .millisecond(0);

      es.eventItem.startDate = combined.toISOString();
    },
    [es.eventItem]
  );

  return (
    <div className='admin-edit-section'>
      <h2>Time*</h2>
      <div className='inputs-container time-settings'>
        <DatePicker
          inputFormat='DD/MM/YYYY'
          label='Date'
          value={es.eventItem.startDate ? dayjs(es.eventItem.startDate).utc() : dayjs()}
          onChange={(selectedDate) => (selectedDate ? getCombinedUTC(selectedDate) : (es.eventItem.startDate = ''))}
        />
        <TimePicker
          label='Time'
          minutesStep={5}
          value={es.eventItem.startDate ? dayjs(es.eventItem.startDate).utc() : null}
          onChange={(selectedTime) => (selectedTime ? getCombinedUTC(selectedTime) : (es.eventItem.startDate = ''))}
          hint='Please add time in UTC standard'
        />
      </div>
    </div>
  );
});

export default DateAndTimeSettings;
